import Vue from 'vue'
import Vuex from 'vuex'
import router from 'vue-router'

import firebaseConfig from "@/firebaseConfig";
import { initializeApp } from "firebase/app";
import { initializeFirestore } from 'firebase/firestore';
import { getStorage } from "firebase/storage";

//import { getAuth, onAuthStateChanged } from "firebase/auth";

import user from './user'
import shared from './shared'
import payments from './payments'

const app = initializeApp(firebaseConfig);


const state = {
  firebase: app,
  db: initializeFirestore(app, {ignoreUndefinedProperties: true}),
  storage: getStorage(app)
  // auth: getAuth(),
  // onAuthStateChanged: onAuthStateChanged(getAuth())
}

Vue.use(Vuex)

export const store = new Vuex.Store({
  state,
  modules: {
    user: user,
    shared: shared,
    payments: payments
  }
})
